import React, { useState, useEffect } from "react";
import { RootState } from "../../models/RootState";
import { NavLink, useParams } from "react-router-dom";
import "./SportsBookMarketPage.scss";
import { connect, useSelector } from "react-redux";
import { EventData, LimitDto, TopicUrls } from "../../models/EventData";
import { IonCol, IonRow } from "@ionic/react";
import { Accordion, AccordionDetails, Button, Checkbox, Tab, Tabs } from "@mui/material";
import TabPanel from "../TabPanel/TabPanel";
import { fetchSREventInfo } from "../../store/exchangeSports/exchangeSportsAction";
import moment from "moment";
import { ExpandLessSharp, ExpandMoreSharp } from "@mui/icons-material";
import LiveStream from "../LiveStream/LiveStream";
import Script from 'next/script';
import { checkStompClientSubscriptions, disconnectToWS, subscribeSportRadarEventOdds } from "../../websockets/webSocket";
import ExchOpenBets from "../ExchOpenBets/ExchOpenBets";
import { UserBet } from "../../models/ExchBetSlip";
import { fetchOpenBets } from "../../store/exchBetSlip/exchBetSlipAction";
import { setEventInfoOnSuccess } from "../../store/exchangeSports/exchangeSportsReducer";
import { removeExchangeBet, setIsOneClickBettingEnabled } from "../../store/exchBetSlip/exchBetSlipReducer";
import { useNavigate } from "react-router";
import { setTextColor } from "../../store/authActions";
import SBMarketsPage from "../SBMarketsPage/SBMarketsPage";
// import Loader from "../../assets/images/Strike_White_Logo_Transparent_GIF.gif";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import OneClickBetting from "../OneClickBetting";
import { Loader } from "../../constants/whitelabelEnv";
import { domain } from "../../constants/Branding"; 

type StoreProps = {
    eventInfo: EventData;
    openBets: UserBet[];
    fetchEventInfo: (sportId: any, eventId: any, navigate: Function) => void;
    fetchOpenBets: (eventId: string, sportId: string) => void;
    setEventInfoOnSuccess: () => void;
    removeExchangeBet: (index: number) => void;
    topicUrls?: TopicUrls;
    sportsRadarWSConnected: boolean;
    wallets: any;
    Browser: any;
    isOneClickBettingEnabled: boolean;
    setIsOneClickBettingEnabled: (isOneClickBettingEnabled: boolean) => void;
};

export const SportsBookMarketPage: React.FC<StoreProps> = (props) => {
    const {
        eventInfo,
        fetchEventInfo,
        openBets,
        fetchOpenBets,
        removeExchangeBet,
        topicUrls,
        sportsRadarWSConnected,
        setEventInfoOnSuccess,
        wallets,
        Browser,
        isOneClickBettingEnabled,
        setIsOneClickBettingEnabled,
    } = props;

    const { gameInfo } = useParams();
    const [sportId, competitionId, eventId] = atob(gameInfo || "").split("|");
    const { exchData } = useSelector((state: RootState) => state.userDetails);
    const [tabVal, setTabVal] = useState(0);
    const [loading, setLoading] = useState<boolean>(false);
    const navigate = useNavigate();
    const [scExpanded, setScExpanded] = useState(true);
    const [lsExpanded, setLsExpanded] = useState(true);
    const [obExpanded, setObExpanded] = useState(true);
    const [prLimits, setPRLimits] = useState<LimitDto>();
    const [bal, setBal] = useState<Number>(0);
    const [exp, setExp] = useState<Number>(0);


    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            await fetchEventInfo(sportId, eventId, navigate);
            fetchOpenBets(eventId, sportId);
            setLoading(false);
        };

        fetchData();
    }, []);

    useEffect(() => {
        const matchingWallet = wallets.find(
            (wallet: any) => wallet?.walletName === "POINTS"
        );
        if (matchingWallet) {
            setBal(matchingWallet?.balance);
            setExp(matchingWallet?.exposure);
        }
    }, [wallets]);

    useEffect(() => {
        return () => {
            setEventInfoOnSuccess()
            removeExchangeBet(0);
            disconnectToWS()
        };
    }, []);

    useEffect(() => {
        if (eventInfo?.eventId && eventInfo?.eventId !== "" && (sportsRadarWSConnected)) {
            if (eventInfo && eventInfo?.markets?.premiumMarkets && eventInfo?.markets?.premiumMarkets?.length > 0 && topicUrls?.premiumTopic) {
                subscribeSportRadarEventOdds(
                    topicUrls?.premiumTopic,
                    "",
                    eventInfo?.eventId
                );
            }
        }
    }, [eventInfo?.eventId, sportsRadarWSConnected]);

    useEffect(() => {
        const handleMessage = (event: MessageEvent) => {
      
          if (event.data?.type === "SCORECARD_HEIGHT") {
            const iframe = document.getElementById("scorecard-frame");
            if (iframe) iframe.style.height = `${event.data.height}px`;
          }
        };
      
        window.addEventListener("message", handleMessage);
        return () => window.removeEventListener("message", handleMessage);
      }, []);

    useEffect(() => {
        if (topicUrls?.premiumBaseUrl) {
            const baseUrlsPayload = {
                matchOddsBaseUrl: topicUrls?.matchOddsBaseUrl,
                bookMakerAndFancyBaseUrl: topicUrls?.bookMakerBaseUrl,
                premiumBaseUrl: topicUrls?.premiumBaseUrl,
            };
            checkStompClientSubscriptions(baseUrlsPayload);
        }
    }, [topicUrls]);

    useEffect(() => {
        if (tabVal === 2) {
            fetchOpenBets(eventInfo?.eventId, eventInfo?.sportId)
        }
    }, [tabVal]);

    useEffect(() => {
        const tg = window?.Telegram?.WebApp;

        tg?.BackButton?.show();

        tg?.expand();

        const telegramVersion = parseFloat(tg?.version || "0");
        if (telegramVersion >= 8.0) {
            // tg?.requestFullscreen();
            tg?.lockOrientation();
        }

        const backClickHandler = () => {
            handleBackClick();
        };

        tg?.BackButton?.onClick(backClickHandler);

        return () => {
            tg?.BackButton?.hide();
            tg?.BackButton?.offClick(backClickHandler);
            const telegramVersion = parseFloat(tg?.version || "0");
            if (telegramVersion >= 8.0) {
                // tg?.exitFullscreen();
                if (tg?.isOrientationLocked) {
                    tg?.unlockOrientation();
                }
            }
        };
    }, []);

    const handleBackClick = () => {
        navigate(-1);
    };

    return (
        <>
            {
                loading ? (
                    <div className="home-loading">
                        <img src={`/${Loader(domain)}`} alt="Loading..." style={{ height: '10rem' }} />
                    </div>
                ) : (
                    <>
                        <IonRow className="sr-ctn">
                            <IonCol className="sr-mob-stream-section">
                                <IonRow className="sr-info-header sr-info-header-name">
                                    <div className="sr-teams-name">
                                        <div className="flex items-center">
                                            {
                                                Browser === "Web" && (
                                                    <div className="flex items-center h-[40px] px-[7px] rounded-[40px] back-btn">
                                                        <FontAwesomeIcon
                                                            icon={faChevronLeft}
                                                            onClick={handleBackClick}
                                                            className="cursor-pointer object-contain shrink-0"
                                                        />
                                                    </div>
                                                )
                                            }
                                            <div className={`${setTextColor(getComputedStyle(document.body).getPropertyValue('--team-info-background'))} sr-teams-name-ctn`}>
                                                <div className="sr-team">{eventInfo?.eventName}</div>
                                                <div className="sr-date-time">
                                                    <span>
                                                        {moment(
                                                            eventInfo?.openDate
                                                        ).format('hh')}
                                                    </span>
                                                    :
                                                    <span>
                                                        {moment(
                                                            eventInfo?.openDate
                                                        ).format('mm A')}
                                                    </span>&nbsp;
                                                    {moment(
                                                        eventInfo?.openDate
                                                    ).format('DD MMM YYYY')}
                                                </div>
                                            </div>

                                        </div>

                                        <div className="sr-bal-ctn">
                                            <div className={`${setTextColor(getComputedStyle(document.body).getPropertyValue('--team-info-background'))} sr-bal`}>
                                                <div>
                                                    {'bal: '}
                                                    <span className="sr-bal-value">{bal.toFixed(2)}</span>
                                                </div>
                                                <div>
                                                    {'exp: ' + exp.toFixed(2)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </IonRow>

                                {
                                    // isMobile &&
                                    (
                                        // openBets.length > 0 ||
                                        // (eventInfo && eventInfo.status === 'IN_PLAY')) ? (
                                        <>
                                            <Tabs
                                                value={tabVal}
                                                className="sr-all-markets-header-tabs"
                                                onChange={(_, newValue) => {
                                                    setTabVal(newValue);
                                                }}
                                            >
                                                <Tab
                                                    label={
                                                        <div className="flex items-center gap-2">
                                                            <span>SCORECARD</span>
                                                            {
                                                                <span onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    setScExpanded(!scExpanded);
                                                                }}
                                                                    className="cursor-pointer">
                                                                    {scExpanded ? <ExpandLessSharp /> : <ExpandMoreSharp />}
                                                                </span>
                                                            }
                                                        </div>
                                                    }
                                                    value={0}
                                                />
                                                {/* {(
                                        <Tab
                                            label={
                                                <div className="flex items-center gap-2">
                                                    <span>LIVE STREAM</span>
                                                    {
                                                        <span onClick={(e) => {
                                                            e.stopPropagation();
                                                            setLsExpanded(!lsExpanded);
                                                        }}
                                                            className="cursor-pointer">
                                                            {lsExpanded ? <ExpandLessSharp /> : <ExpandMoreSharp />}
                                                        </span>
                                                    }
                                                </div>
                                            }
                                            value={1}
                                            disabled={
                                                !(eventInfo && eventInfo.status === 'IN_PLAY')
                                            }
                                        />
                                    )} */}
                                                <Tab
                                                    label={
                                                        <div className="flex items-center gap-2">
                                                            <span>OPEN BETS ({openBets?.length || 0}) </span>
                                                            {
                                                                <span onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    setObExpanded(!obExpanded);
                                                                }}
                                                                    className="cursor-pointer">
                                                                    {obExpanded ? <ExpandLessSharp /> : <ExpandMoreSharp />}
                                                                </span>
                                                            }
                                                        </div>
                                                    }
                                                    value={2}
                                                />
                                            </Tabs>
                                            <TabPanel
                                                value={tabVal}
                                                index={0}
                                                className="srevent-stat-mobile-ctn"
                                            >
                                                <div>
                                                    {tabVal === 0 &&
                                                        eventInfo ? (
                                                        <>
                                                            {scExpanded && (
                                                                <Accordion
                                                                    className="srscorecard-accordion"
                                                                    expanded={true}
                                                                >
                                                                    <AccordionDetails className="sr-scorecard-detail">
                                                                        <div className="widgets">
                                                                            <div>
                                                                                <div className="sr-widget sr-widget-1">
                                                                                    {eventInfo && (
                                                                                        <iframe
                                                                                            id="scorecard-frame"
                                                                                            src={`https://win.mysportsfeed.io/?sportId=${eventInfo.sportId}&eventId=${eventInfo.eventId}`}
                                                                                            width="100%"
                                                                                            height="0"
                                                                                            title="Scorecard"
                                                                                        />
                                                                                    )}
                                                                                </div>
                                                                                {/* <>
                                                                                    {eventInfo?.catId?.toLowerCase() === "sr virtual" ? (
                                                                                        <Script
                                                                                            strategy="afterInteractive"
                                                                                            dangerouslySetInnerHTML={{
                                                                                                __html: `
                                                                                            (function(a,b,c,d,e,f,g,h,i){a[e]||(i=a[e]=function(){(a[e].q=a[e].q||[]).push(arguments)},i.l=1*new Date,i.o=f, 
                                                                                g=b.createElement(c),h=b.getElementsByTagName(c)[0],g.async=1,g.src=d,g.setAttribute("n",e),h.parentNode.insertBefore(g,h))})(window,document,"script", 
                                                                                "https://widgets.sir.sportradar.com/8ee45b574e2781d581b0b0a133803906/widgetloader", "SIR", { 
                                                                                    theme: false, // using custom theme 
                                                                                    language: "en" // other languages are available like en, fr, de, pl, ... 
                                                                                }); 
                                                                                SIR("addWidget", ".sr-widget-1", "match.lmtPlus", { 
                                                                                    layout: "topdown",  
                                                                                    matchId:"${eventInfo?.eventId}"
                                                                                    // add more optional parameters here 
                                                                                })
                                                                                                    `,
                                                                                            }}
                                                                                        />
                                                                                    ) : eventInfo?.eventId && (
                                                                                        <Script
                                                                                            strategy="afterInteractive"
                                                                                            dangerouslySetInnerHTML={{
                                                                                                __html: `
                                                                                        (function(a,b,c,d,e,f,g,h,i){a[e]||(i=a[e]=function(){(a[e].q=a[e].q||[]).push(arguments)},i.l=1*new Date,i.o=f,
                                                                                        g=b.createElement(c),h=b.getElementsByTagName(c)[0],g.async=1,g.src=d,g.setAttribute("n",e),h.parentNode.insertBefore(g,h)
                                                                                        )})(window,document,"script", "https://widgets.sir.sportradar.com/8ee45b574e2781d581b0b0a133803906/widgetloader", "SIR", {
                                                                                            theme: false, // using custom theme
                                                                                            language: "en"
                                                                                        });
                                                                                        SIR("addWidget", ".sr-widget-1", "match.lmtPlus", {layout: "double", scoreboard: "extended", momentum: "extended", collapseTo: "momentum", matchId:${eventInfo?.eventId?.split("sr:match:")?.[1]}});
                                                                                        `,
                                                                                            }}
                                                                                        />
                                                                                    )}
                                                                                </> */}
                                                                            </div>
                                                                        </div>
                                                                    </AccordionDetails>
                                                                </Accordion>
                                                            )}
                                                        </>
                                                    ) : null}
                                                </div>
                                            </TabPanel>
                                            {/* <TabPanel
                                    value={tabVal}
                                    index={1}
                                    className="sr-header-tab-panel"
                                >
                                    {tabVal === 1 ? (
                                        <>
                                            {lsExpanded && (
                                                <div className="live-stream-ctn">
                                                    <LiveStream
                                                        eventID={eventInfo.eventId}
                                                    />
                                                </div>
                                            )}
                                        </>
                                    ) : null}
                                </TabPanel> */}
                                            <TabPanel
                                                value={tabVal}
                                                index={2}
                                                className="srevent-stat-mobile-ctn"
                                            >
                                                {obExpanded && (
                                                    <>
                                                        {openBets.length > 0 ? (
                                                            <ExchOpenBets />
                                                        ) : (
                                                            <>
                                                                <div className="no-bet-data mob-open-bets-ctn">
                                                                    {"No open bets to show"}
                                                                </div>
                                                            </>
                                                        )}
                                                        <div className="btn-background">
                                                            <div className={`${setTextColor(getComputedStyle(document.body).getPropertyValue('--ion-button-color'))} btn-mybets`}>
                                                                <NavLink to={`/betlist`}>
                                                                    <Button>{"VIEW ALL"}</Button>
                                                                </NavLink>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                            </TabPanel>
                                        </>
                                    )}
                            </IonCol>
                            <IonCol className="sr-events-table-section">
                                {eventInfo?.markets?.premiumMarkets?.length > 0 ? (
                                    <div className="">
                                        <IonRow className="sr-table-section">
                                            <SBMarketsPage />
                                        </IonRow>
                                    </div>

                                ) : eventInfo?.eventId && (
                                    <div className="no-fancy-msg">No Markets Available</div>)}

                                {isOneClickBettingEnabled ? (
                                    <div className="fixed bottom-3 left-1/2 -translate-x-1/2 z-[1000] w-[95%] max-w-[450px]">
                                        <OneClickBetting lobby={"SPORTSBOOK"} />
                                    </div>
                                ) : (
                                    <div
                                        className="bg-[var(--sb-mkt-name-bg)] rounded-lg p-2 m-1 flex items-center justify-between"
                                    >
                                        <div
                                            className="flex items-center text-xs text-gray-200 font-medium"
                                        >
                                            <Checkbox
                                                color="primary"
                                                onClick={() => {
                                                    setIsOneClickBettingEnabled(!isOneClickBettingEnabled)
                                                }}
                                                checked={isOneClickBettingEnabled}
                                                className="text-[var(--ion-color-primary)] pr-1"
                                                size="small"
                                                style={{
                                                    padding: '0px',
                                                    transform: 'scale(0.7)',
                                                    color: 'var(--ion-color-primary)'
                                                }}
                                            />
                                            1 Click Betting Enabled
                                        </div>
                                    </div>
                                )}
                            </IonCol>
                        </IonRow>
                    </>
                )
            }
        </>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        topicUrls: state?.exchangeSports?.topicUrls,
        eventInfo: state?.exchangeSports.eventInfo,
        sportsRadarWSConnected: state?.exchangeSports?.sportsRadarWSConnected,
        openBets: state?.exchBetSlip?.openBets,
        wallets: state.userDetails?.wallets,
        Browser: state.userDetails.Browser,
        isOneClickBettingEnabled: state?.exchBetSlip?.isOneClickBettingEnabled,
    };
};

const mapDispatchToProps = (dispatch: Function) => {
    return {
        removeExchangeBet: (index: number) => dispatch(removeExchangeBet(index)),
        setEventInfoOnSuccess: () => dispatch(setEventInfoOnSuccess({})),
        fetchOpenBets: (eventId: string, sportId: string) => dispatch(fetchOpenBets(eventId, sportId)),
        fetchEventInfo: (sportId: string, eventId: string, navigate: Function) => dispatch(fetchSREventInfo(sportId, eventId, navigate)),
        setIsOneClickBettingEnabled: (isOneClickBettingEnabled: boolean) => dispatch(setIsOneClickBettingEnabled(isOneClickBettingEnabled)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SportsBookMarketPage);
